import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import { Map, List } from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Map({}).set('Get', new List([])).set('Search', new List([]))

/* Types */
export const GET_GRANTEES = 'GET_GRANTEES'
export const SEARCH_GRANTEES = 'SEARCH_GRANTEES'
export const REACTIVATE_PAY = 'REACTIVATE_PAY'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_GRANTEES:
			return state.set('Get', new List(action.Obj))
		case SEARCH_GRANTEES:
			return state.set('Search', new List(action.Obj))
		case REACTIVATE_PAY:
			return state.set('Response', new List(action.Obj))
		default:
			return state
	}
}

/* Action Creators */

export const getGrantees = () => {

	let temp = {
		idCorrida: null,
		idTipoPago: 2
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getGrantees',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {

			dispatch(isLoading(false))

			let contabilizadas = []
			response.data.map(item => {
				contabilizadas.push({
					idDonataria: item.donataria.idDonataria,
					nombreDonataria: item.donataria.nombreDonataria,
					corridaId: item.corrida.corridaId,
					nombreCorrida: item.corrida.nombre
				})
			})
			dispatch({ type: GET_GRANTEES, Obj: contabilizadas })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}

}

export const getConsultantGrantees = () => {

	let temp = {
		idCorrida: null,
		idTipoPago: null
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getGrantees',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {

			dispatch(isLoading(false))

			let contabilizadas = []
			response.data.map(item => {
				contabilizadas.push({
					idDonataria: item.donataria.idDonataria,
					nombreDonataria: item.donataria.nombreDonataria,
					corridaId: item.corrida.corridaId,
					nombreCorrida: item.corrida.nombre
				})
			})
			dispatch({ type: SEARCH_GRANTEES, Obj: contabilizadas })
			return response.contabilizadas
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}

}

export const updatePayment = (form) => {

	let temp = {
		"donataria": {
			"idDonataria": form.idDonataria,
			"nombreDonataria": form.nombreDonataria,
			"idCorrida": form.corridaId,
			"descripcionOportunidad": form.nombreCorrida,
			"reactivacion": true
		}
	}

	return (dispatch) => {
		dispatch(isLoading(true))
		return new ClientHttpRequest({
			service: 'api/updatePayment',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}



// WEBPACK FOOTER //
// ./src/modules/MissingInfo/Grantees/index.js